import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import type { DataIdentifier } from '@onefootprint/request-types';
import { Form, Toggle } from '@onefootprint/ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SsnDisclaimer } from './ssn-disclaimer';
type SsnOrTaxIdProps = {
  attributes: string[];
  disabledDis: DataIdentifier[];
  isOptional?: boolean;
  isSkipped?: boolean;
  onSkipChange?: () => void;
  disableSsnValidation?: boolean;
  scrubbedSsn9Value?: string;
};
export const SsnOrTaxId = t0 => {
  const $ = _c(90);
  const {
    attributes,
    disabledDis,
    isOptional,
    isSkipped: t1,
    onSkipChange,
    disableSsnValidation,
    scrubbedSsn9Value
  } = t0;
  const isSkipped = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "collectData"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  const {
    setValue
  } = useFormContext();
  let t3;
  if ($[1] !== attributes) {
    t3 = attributes.includes("ssn4");
    $[1] = attributes;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const showSsn4 = t3;
  let t4;
  if ($[3] !== attributes) {
    t4 = attributes.includes("ssn9");
    $[3] = attributes;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const showSsn9 = t4;
  let t5;
  if ($[5] !== attributes) {
    t5 = attributes.includes("us_tax_id");
    $[5] = attributes;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const showUsTaxId = t5;
  let t6;
  if ($[7] !== isSkipped || $[8] !== onSkipChange || $[9] !== setValue || $[10] !== showSsn4 || $[11] !== showSsn9 || $[12] !== showUsTaxId) {
    t6 = () => {
      if (!isSkipped) {
        if (showSsn4) {
          setValue(diToFormData("id.ssn4"), "");
        }
        if (showSsn9) {
          setValue(diToFormData("id.ssn9"), "");
        }
        if (showUsTaxId) {
          setValue(diToFormData("id.us_tax_id"), "");
        }
      }
      onSkipChange?.();
    };
    $[7] = isSkipped;
    $[8] = onSkipChange;
    $[9] = setValue;
    $[10] = showSsn4;
    $[11] = showSsn9;
    $[12] = showUsTaxId;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleSkipChange = t6;
  if (showUsTaxId) {
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = diToFormData("id.us_tax_id");
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== t) {
      t8 = t(_temp);
      $[15] = t;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== isSkipped || $[18] !== t) {
      t9 = isSkipped ? false : t(_temp2);
      $[17] = isSkipped;
      $[18] = t;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== t9) {
      t10 = {
        required: t9
      };
      $[20] = t9;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    let t11;
    if ($[22] !== disabledDis || $[23] !== isSkipped) {
      t11 = isSkipped || disabledDis.includes("id.us_tax_id");
      $[22] = disabledDis;
      $[23] = isSkipped;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    let t12;
    if ($[25] !== disableSsnValidation || $[26] !== t10 || $[27] !== t11 || $[28] !== t8) {
      t12 = <Form.UsTaxId name={t7} data-auto-advance={true} data-nid-target="us-tax-id" data-dd-privacy="mask" label={t8} rules={t10} disabled={t11} useLenientValidation={disableSsnValidation} />;
      $[25] = disableSsnValidation;
      $[26] = t10;
      $[27] = t11;
      $[28] = t8;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    let t13;
    if ($[30] !== handleSkipChange || $[31] !== isOptional || $[32] !== isSkipped || $[33] !== t) {
      t13 = isOptional && <Toggle label={t(_temp3)} checked={isSkipped} onChange={handleSkipChange} />;
      $[30] = handleSkipChange;
      $[31] = isOptional;
      $[32] = isSkipped;
      $[33] = t;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    let t14;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <SsnDisclaimer variant="usTaxId" />;
      $[35] = t14;
    } else {
      t14 = $[35];
    }
    let t15;
    if ($[36] !== t12 || $[37] !== t13) {
      t15 = <>{t12}{t13}{t14}</>;
      $[36] = t12;
      $[37] = t13;
      $[38] = t15;
    } else {
      t15 = $[38];
    }
    return t15;
  }
  if (showSsn9) {
    let t7;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = diToFormData("id.ssn9");
      $[39] = t7;
    } else {
      t7 = $[39];
    }
    let t8;
    if ($[40] !== t) {
      t8 = t(_temp4);
      $[40] = t;
      $[41] = t8;
    } else {
      t8 = $[41];
    }
    let t9;
    if ($[42] !== isSkipped || $[43] !== scrubbedSsn9Value || $[44] !== t) {
      t9 = isSkipped || scrubbedSsn9Value ? false : t(_temp5);
      $[42] = isSkipped;
      $[43] = scrubbedSsn9Value;
      $[44] = t;
      $[45] = t9;
    } else {
      t9 = $[45];
    }
    let t10;
    if ($[46] !== t9) {
      t10 = {
        required: t9
      };
      $[46] = t9;
      $[47] = t10;
    } else {
      t10 = $[47];
    }
    let t11;
    if ($[48] !== disabledDis || $[49] !== isSkipped) {
      t11 = isSkipped || disabledDis.includes("id.ssn9");
      $[48] = disabledDis;
      $[49] = isSkipped;
      $[50] = t11;
    } else {
      t11 = $[50];
    }
    let t12;
    if ($[51] !== disableSsnValidation || $[52] !== scrubbedSsn9Value || $[53] !== t10 || $[54] !== t11 || $[55] !== t8) {
      t12 = <Form.Ssn9 name={t7} data-auto-advance={true} scrubbedSsn9Value={scrubbedSsn9Value} data-nid-target="ssn9" data-dd-privacy="mask" label={t8} rules={t10} disabled={t11} useLenientValidation={disableSsnValidation} defaultVisible={true} />;
      $[51] = disableSsnValidation;
      $[52] = scrubbedSsn9Value;
      $[53] = t10;
      $[54] = t11;
      $[55] = t8;
      $[56] = t12;
    } else {
      t12 = $[56];
    }
    let t13;
    if ($[57] !== handleSkipChange || $[58] !== isOptional || $[59] !== isSkipped || $[60] !== t) {
      t13 = isOptional && <Toggle label={t(_temp6)} checked={isSkipped} onChange={handleSkipChange} />;
      $[57] = handleSkipChange;
      $[58] = isOptional;
      $[59] = isSkipped;
      $[60] = t;
      $[61] = t13;
    } else {
      t13 = $[61];
    }
    let t14;
    if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <SsnDisclaimer variant="ssn9" />;
      $[62] = t14;
    } else {
      t14 = $[62];
    }
    let t15;
    if ($[63] !== t12 || $[64] !== t13) {
      t15 = <>{t12}{t13}{t14}</>;
      $[63] = t12;
      $[64] = t13;
      $[65] = t15;
    } else {
      t15 = $[65];
    }
    return t15;
  }
  if (showSsn4) {
    let t7;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = diToFormData("id.ssn4");
      $[66] = t7;
    } else {
      t7 = $[66];
    }
    let t8;
    if ($[67] !== t) {
      t8 = t(_temp7);
      $[67] = t;
      $[68] = t8;
    } else {
      t8 = $[68];
    }
    let t9;
    if ($[69] !== isSkipped || $[70] !== t) {
      t9 = isSkipped ? false : t(_temp8);
      $[69] = isSkipped;
      $[70] = t;
      $[71] = t9;
    } else {
      t9 = $[71];
    }
    let t10;
    if ($[72] !== t9) {
      t10 = {
        required: t9
      };
      $[72] = t9;
      $[73] = t10;
    } else {
      t10 = $[73];
    }
    let t11;
    if ($[74] !== disabledDis || $[75] !== isSkipped) {
      t11 = isSkipped || disabledDis.includes("id.ssn4");
      $[74] = disabledDis;
      $[75] = isSkipped;
      $[76] = t11;
    } else {
      t11 = $[76];
    }
    let t12;
    if ($[77] !== t10 || $[78] !== t11 || $[79] !== t8) {
      t12 = <Form.Ssn4 name={t7} data-auto-advance={true} data-nid-target="ssn4" data-dd-privacy="mask" label={t8} rules={t10} disabled={t11} />;
      $[77] = t10;
      $[78] = t11;
      $[79] = t8;
      $[80] = t12;
    } else {
      t12 = $[80];
    }
    let t13;
    if ($[81] !== handleSkipChange || $[82] !== isOptional || $[83] !== isSkipped || $[84] !== t) {
      t13 = isOptional && <Toggle label={t(_temp9)} checked={isSkipped} onChange={handleSkipChange} />;
      $[81] = handleSkipChange;
      $[82] = isOptional;
      $[83] = isSkipped;
      $[84] = t;
      $[85] = t13;
    } else {
      t13 = $[85];
    }
    let t14;
    if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <SsnDisclaimer variant="ssn4" />;
      $[86] = t14;
    } else {
      t14 = $[86];
    }
    let t15;
    if ($[87] !== t12 || $[88] !== t13) {
      t15 = <>{t12}{t13}{t14}</>;
      $[87] = t12;
      $[88] = t13;
      $[89] = t15;
    } else {
      t15 = $[89];
    }
    return t15;
  }
  return null;
};
function _temp($) {
  return $.fields.ssn.usTaxId.label;
}
function _temp2($_0) {
  return $_0.fields.ssn.usTaxId.error.required;
}
function _temp3($_1) {
  return $_1.fields.ssn.skipLabel;
}
function _temp4($_2) {
  return $_2.fields.ssn.ssn9.label;
}
function _temp5($_3) {
  return $_3.fields.ssn.ssn9.error.required;
}
function _temp6($_4) {
  return $_4.fields.ssn.skipLabel;
}
function _temp7($_5) {
  return $_5.fields.ssn.ssn4.label;
}
function _temp8($_6) {
  return $_6.fields.ssn.ssn4.error.required;
}
function _temp9($_7) {
  return $_7.fields.ssn.skipLabel;
}